window.process = {
    env: { DEBUG: undefined },
};
